import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import { NavLink, useLocation } from "react-router-dom";
import MobileMenu from "./MobileMenu";

const Navbar = () => {
    const { posts, randomizeColor } = useContext(AppContext);
    const { pathname } = useLocation();

    const postsLink = posts.length > 0 ? `/posts/${posts[0].filename}` : "/";
    // Any post counts as active, not only the first one.
    const postsActive = pathname.startsWith("/posts/");

    return <header className={`flex items-center md:items-baseline justify-between gap-x-8`}>
        <NavLink to="/" title="neta.lol (click for a new color)" onClick={randomizeColor}
            className={`text-accent text-4xl sm:text-5xl font-semibold tracking-tight select-none transition-colors duration-700`}>
            neta.lol
        </NavLink>
        <nav className={`hidden md:flex flex-wrap items-baseline gap-x-10 text-2xl lg:text-3xl font-semibold`}>
            <NavLink to={postsLink}
                className={postsActive ? `text-white` : `text-accent hover:text-white transition-colors`}>
                posts
            </NavLink>
        </nav>
        <MobileMenu />
    </header>
}

export default Navbar;
